import { HistoryInteractionBar } from "./HistoryInteractionBar";
import { useStyle } from "./style";
import { InteractionWorkspaceProps } from "./types";
import { InteractionType } from "@/common/types";
import { EmailHistoryInteractionContent } from "./EmailHistoryInteractionContent";
import { Flex } from "@/components/atoms/flex";
import { useCallback, useEffect } from "react";
import { useIntl } from "react-intl";
import { UnavailableConversationPlaceholder } from "./UnavailableConversationPlaceholder";
import { mergeClasses } from "@fluentui/react-components";
import { VoicemailHistoryInteractionContent } from "./VoicemailHistoryInteractionContent";
import { MessagingChatHistoryInteractionContent } from "./MessagingChatHistoryInteractionContent";
import { chatInteractionTypes } from "@/common/helpers";
import { VoiceHistoryInteractionContent } from "./VoiceHistoryInteractionContent";
import { auditHistoryViewDetails } from "@/repository/queryFns/history";
import MessageOutlet from "@/common/messages/outlet";

export const InteractionHistory = (props: InteractionWorkspaceProps) => {
	const { historyItem } = props;

	const classes = useStyle();

	const intl = useIntl();

	const hasRecording = historyItem?.hasRecording;
	const interactionId = historyItem?.interactionId;

	useEffect(() => {
		if (hasRecording && interactionId) {
			auditHistoryViewDetails(interactionId).catch((err) => {
				// eslint-disable-next-line no-console
				console.debug("auditHistoryViewDetails failed (non-blocking):", err);
			});
		}
	}, [hasRecording, interactionId]);

	const workspaceContent = useCallback(() => {
		if (
			(historyItem.type == InteractionType.Email ||
				historyItem.type == InteractionType.WhatsApp ||
				historyItem.type == InteractionType.Webchat) &&
			historyItem.isMissed
		) {
			return (
				<UnavailableConversationPlaceholder
					message={intl.formatMessage({
						id: "History.InteractionContentNotAvailable",
					})}
				/>
			);
		}

		if (historyItem.type === InteractionType.Email) {
			return <EmailHistoryInteractionContent historyItem={historyItem} />;
		}

		if (chatInteractionTypes.includes(historyItem.type)) {
			return (
				<MessagingChatHistoryInteractionContent historyItem={historyItem} />
			);
		}

		if (historyItem.type === InteractionType.Voicemail) {
			return <VoicemailHistoryInteractionContent historyItem={historyItem} />;
		}

		if (historyItem.type === InteractionType.Call) {
			return <VoiceHistoryInteractionContent historyItem={historyItem} />;
		}

		return <></>;
	}, [historyItem]);

	return (
		<Flex
			className={mergeClasses(
				classes.workspaceContainer,
				chatInteractionTypes.includes(historyItem.type) &&
					classes.workspaceContainerLight
			)}
		>
			<Flex column className={classes.interactionBarContainer}>
				<MessageOutlet namespace="historyWorkspace" style={{margin: "0px 16px"}}/>
				<HistoryInteractionBar historyItem={props.historyItem} />

				<>{workspaceContent()}</>
			</Flex>
		</Flex>
	);
};
